export default {
  path: '/delivery-status',
  name: 'delivery-status',
  redirect: '/dashboard',
  meta: {
    metaTags: [
      {
        content: 'View the status of all your Etsy shipments from the last year on one page with eRank’s Delivery Status Report.',
        name: 'description',
      },
      {
        page_slug: 'delivery-status',
      },
    ],
    requiresAuth: true,
    title: 'eRank — Delivery Status',
  },
};